"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const cart_items_1 = require("../styles/cart-items");
const remove_item_1 = __importDefault(require("./remove-item"));
const remove_loyalty_1 = __importDefault(require("./remove-loyalty"));
const Remove = ({ item, isNewItem, isLoyalty, isExpired, cartType }) => {
    if (isNewItem || isExpired)
        return null;
    return ((0, jsx_runtime_1.jsxs)(cart_items_1.RemoveItem, { children: [isLoyalty && (0, jsx_runtime_1.jsx)(remove_loyalty_1.default, { item: item }), !isLoyalty && (0, jsx_runtime_1.jsx)(remove_item_1.default, { item: item, cartType: cartType })] }));
};
exports.default = Remove;
